import { apiInstance } from "../networking";

export const getBinaryUserDataPanDob = async ({ txnId, channelUrl }) => {
  const { data = {} } = await apiInstance.get(
    `/primary/metadata?txnId=${txnId}&channel=${channelUrl}`
  );
  return data;
};
